import { render, staticRenderFns } from "./MSV.vue?vue&type=template&id=2c09ecd9"
import script from "./MSV.vue?vue&type=script&lang=js"
export * from "./MSV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c09ecd9')) {
      api.createRecord('2c09ecd9', component.options)
    } else {
      api.reload('2c09ecd9', component.options)
    }
    module.hot.accept("./MSV.vue?vue&type=template&id=2c09ecd9", function () {
      api.rerender('2c09ecd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/OtherTargetMaintain/MSV.vue"
export default component.exports